import { render, staticRenderFns } from "./Bracket.vue?vue&type=template&id=4a20e708&"
import script from "./Bracket.vue?vue&type=script&lang=js&"
export * from "./Bracket.vue?vue&type=script&lang=js&"
import style0 from "./Bracket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports